import { AlreadyTranslated, AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AttributeResource } from '../../../../../../Types';

export interface Props {
  competency: AttributeResource;
}

const Label: React.FC<Props> = ({ competency }) =>
  competency.payload.name
    .map((name: AlreadyTranslatedText) => (
      <div
        className="text-gray-900 border border-gray-900 break-keep inline-block rounded-md py-1
                   px-2 text-xs font-medium tracking-tight"
      >
        <AlreadyTranslated content={name} />
      </div>
    ))
    .getOrElse(() => <></>);

export default observer(Label);
